/*
 * Copyright (c) 2022 EGT Digital - All rights reserved.
 *
 * File: Balance.tsx
 *
 * Written by Martin Lubenov <martin.lubenov@egt-digital.com> on  27.10.22 2:06 pm.
 * Last modified: 27.10.22 2:06 pm.
 *
 * More information at: https://egt-digital.com/
 */
import React, { useEffect, useState } from 'react';
import { useTranslator } from '../contexts/TranslatorContext';
import store from '../eventStore';
import IBalance from '../interfaces/IBalance';

const Balance = ({ mode }: { mode: 'desktop' | 'mobile' }) => {
    const [balance, setBalance] = useState<IBalance>(store.BALANCE.value);
    const translate = useTranslator();

    useEffect(() => {
        const balanceSubscription = store.BALANCE.subscribe(newBalance => setBalance(newBalance));

        return () => balanceSubscription.unsubscribe();
    }, []);

    return (
        <>
            <div className={`egt_lobby_balance ${mode === 'mobile' ? 'portrait-only' : ''}`}>
                <span className="egt_lobby_balanceAmount">
                    <span className="egt_lobby_amount">{balance.formattedBalance}</span>
                    <span className="egt_lobby_currency">{balance.currency}</span>
                </span>
                <span className="egt_lobby_balanceCaption">{translate('BALANCE')}</span>
            </div>

            {mode === 'mobile' && (
                <div className="egt_lobby_balance-landscape landscape-only">
                    <span className="egt_lobby_balanceCaption">{translate('BALANCE')}:</span>
                    <span className="egt_lobby_balanceAmount">
                        <span className="egt_lobby_amount">{balance.formattedBalance}</span>
                        <span className="egt_lobby_currency">{balance.currency}</span>
                    </span>
                </div>
            )}
        </>
    );
};

export default Balance;
